import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import generateURL from '../../generateURL';
import { CONTEXT } from '../../../../config';
import useLog from '../../hooks/useLog';
import usePay from '../../hooks/usePay';
import { scrollSave } from '../../../../actions/game';

export default ({ children, to, info, source, data = {}, logInfo: { category, action, params = {}, bizInfo } = {}, ...extProps }) => {
  const dispatch = useDispatch();
  const [report, track] = useLog();
  const pay = usePay();
  to = to || generateURL(info);

  const _DataReport = () => {
    report(category, action, params, bizInfo);
  };

  if (to.external) {
    return (
      <a href={to.url} target="_blank" {...extProps} onClick={_DataReport}>
        {children}
      </a>
    );
  }

  if (to.pay) {
    return (
      <a {...extProps} onClick={ e => {
        e.preventDefault()
        _DataReport()
        pay(to.url, source, data)
      } }>
        {children}
      </a>
    );
  }

  return (
    <Link to={to.url} {...extProps} onClick={ () => {
      _DataReport()
      track(2, source)
      dispatch(scrollSave())
    } }>
      {children}
    </Link>
  );
};
